import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import CustomHTML from './customHTML';
import PresentationHeading from './presentation-heading';

export const CustomPresentation = observer(
    ({ ui, onAction, onNextQuestion }) => {
        const { t } = useTranslation('assessment');
        return (
            <div className="assessment-presentation">
                <div className="question">
                    <PresentationHeading ui={ui} t={t} />
                    <CustomHTML
                        ui={ui}
                        onAction={onAction}
                        onNextQuestion={onNextQuestion}
                    />
                </div>
            </div>
        );
    }
);
